class CategoryScripts {
	constructor() {
        ( function ( $ ) {
            "use strict";

        if ($('#categoria-produtos').length) {
            // console.log('Página de categoria de produto');

            function getUrlParameter(name) {
                let regex = new RegExp('[?&]' + name + '=([^&#]*)');
                let results = regex.exec(window.location.search);
                return results === null ? null : decodeURIComponent(results[1]);
            }

            window.filtrando_produtos_contador = 0;
            $('.filtros-categoria.filtros-mobile .gaia_product_filter_item:checked').each(function() {
                window.filtrando_produtos_contador += 1;
            });
            $('.gaia_archive_mobile_filters .number').html(window.filtrando_produtos_contador);

            window.filtrando_produtos = false;
            function applyFilters(order) {
                let filters = {};
                let button = $('.gaia_load_more_category');
                let container = $('.filter_content');
                let category = container.data('category');
                let orderby = '';
                let orderby_param = '';
                if (order) {
                    orderby = order;
                    orderby_param = '&orderby=' + order;
                } else if (getUrlParameter('orderby')) {
                    orderby = getUrlParameter('orderby');
                    orderby_param = '&orderby=' + orderby;
                }
        
                // Captura todos os filtros selecionados
                window.filtrando_produtos_contador = 0;
                $('.gaia_product_filter_item:checked').each(function() {
                    let filter = $(this).data('filter');
                    let value = $(this).val();
                    if (!filters[filter]) {
                        filters[filter] = [];
                    }
                    if (!filters[filter].includes(value)) filters[filter].push(value);
                    window.filtrando_produtos_contador++;
                });
                // console.log(filters);
                $('.gaia_archive_mobile_filters .number').html(window.filtrando_produtos_contador);

                // Constrói a query string para a URL
                let queryString = $.param(filters);
                let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + queryString + '&page=1' + orderby_param;

                // Atualiza a URL sem recarregar a página
                history.pushState(null, null, newUrl);

                 // Dispara o evento customizado 'applyFilters'
                $(document).trigger('applyFilters', ['start', filters]);
        
                // Envia os filtros via AJAX
                $.ajax({
                    url: gaiaCustomData.ajax_url, // O URL do AJAX
                    type: 'POST',
                    data: {
                        action: 'gaia_filter_products_cat', // Nome da ação AJAX
                        filters: filters,
                        category: category,
                        orderby: orderby
                    },
                    beforeSend: function( xhr ) {
                        // console.log('Iniciando filtro de produtos');
                    },
                    success: function(response) {
                        if (response.success) {
                            $('.gaia_grid_products').html(response.data.html);
                            $('.filter_content').data('max-pages', response.data.max_pages);
                            container.data('current-page', response.data.current_page);

                            // Ocultar botão ver mais
                            if (response.data.current_page >= response.data.max_pages) {
                                button.parent().hide();
                            } else {
                                button.parent().show();
                            }
                        }
                    }
                })
                .done(function() {
                    $(document).trigger('applyFilters', ['end', filters]);
                })
                .fail(function() {
                    alert( t('category.error_filter_products') );
                });
            }

            // Aplica filtros ao carregar a página, se houver parâmetros na URL
            function applyFiltersFromUrl() {
                let params = new URLSearchParams(window.location.search);

                params.forEach((value, key) => {
                    // Marca os checkboxes correspondentes
                    $(`.filter[data-filter="${key}"][value="${value}"]`).prop('checked', true);
                });

                // Se houver filtros na URL, aplica-os
                if (params.toString()) {
                    applyFilters();
                } else {
                    setTimeout(() => {
                        $('.product_item_grid').removeClass('loading');
                    }, 500);
                }
            }
        
            // Escuta as mudanças nos filtros
            $('.gaia_product_filter_item').on('change', function() {
                if (window.filtrando_produtos) return;
                
                // Desativa temporariamente o evento 'change' no outro select
                window.filtrando_produtos = true;
            
                // Atualiza o select correspondente
                const value = $(this).val();
                const isChecked = $(this).is(':checked');
                $(`.gaia_product_filter_item[value="${value}"]`).each(function() {
                    if (this !== event.target) {
                        $(this).prop('checked', isChecked);
                    }
                });
            
                // Reativa o evento 'change' nos selects
                window.filtrando_produtos = false;
            
                // Aplica os filtros
                applyFilters();
            });

            // Aplica os filtros da URL ao carregar a página
            applyFiltersFromUrl();

            // Escuta o evento 'applyFilters'
            $(document).on('applyFilters', function(event, type, filters) {
                // console.log(event, type);
                if ('start' == type) {
                    $('.product_item_grid').addClass('loading');
                } else if ('end' == type) {
                    setTimeout(() => {
                        $('.product_item_grid').removeClass('loading');
                    }, 1500);
                }
            });

            // AJAX paginação de produtos da categoria
            $('.gaia_load_more_category').on('click', function() {
                let button = $(this);
                let filters = {};
                let container = $('.filter_content');
                let currentPage = container.data('current-page');
                let maxPages = container.data('max-pages');
                let category = container.data('category');
                let orderby = getUrlParameter('orderby');
                let orderby_param = orderby ? '&orderby=' + orderby : '';
        
                // Atualiza o número da página
                let nextPage = parseInt(currentPage) + 1;

                // Captura todos os filtros selecionados
                $('.gaia_product_filter_item:checked').each(function() {
                    let filter = $(this).data('filter');
                    if (!filters[filter]) {
                        filters[filter] = [];
                    }
                    filters[filter].push($(this).val());
                });

                // Constrói a query string para a URL
                let queryString = $.param(filters);
                let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + queryString + '&page=' + nextPage + orderby_param;

                // Atualiza a URL sem recarregar a página
                history.pushState(null, null, newUrl);
        
                // Desativa o botão enquanto a requisição está em andamento
                button.addClass('loading');
                
                // Faz a requisição AJAX
                $.ajax({
                    url: gaiaCustomData.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'gaia_load_more_category',
                        filters: filters,
                        category: category,
                        page: nextPage,
                        orderby: orderby
                    },
                    success: function(response) {
                        if (response.success) {
                            // Adiciona os novos produtos ao container
                            var newItems = $(response.data.html).hide();
                            container.find('.gaia_grid_products').append(newItems);
                            newItems.fadeIn('slow');
                            
                            // Atualiza o número da página atual
                            container.data('current-page', nextPage);

                            // Rolagem suave até os novos produtos inseridos
                            $('html, body').animate({
                                scrollTop: newItems.first().offset().top
                            }, 'slow');
        
                            // Oculta o botão de "Veja mais" se chegou ao máximo de páginas
                            if (nextPage >= maxPages) {
                                button.parent().hide();
                            }
                        } else {
                            // console.log('Erro ao carregar mais produtos.');
                        }
                    },
                    error: function(error) {
                        console.log(error);
                    },
                    complete: function() {
                        // Remove a classe de loading e restaura o botão
                        button.removeClass('loading');
                    }
                });
            });

            // Change default WC Order products
            $('select[name="gaia_orderby"]').on('change', function(e) {
                e.preventDefault();
                const order = $(this).val();
                applyFilters(order);
            });

            // Verifica o valor do parâmetro "page"
            let page = getUrlParameter('page');

            if (page && page > 1) {
                // Obter o número de produtos por página (ajuste conforme necessário)
                let postsPerPage = 9;
        
                // Calcular o índice do primeiro item da página atual
                let firstItemIndex = (page - 1) * postsPerPage;
        
                // Obter todos os produtos na página
                let $products = $('.gaia_grid_products .product_item_grid');
        
                // Verificar se o primeiro item existe
                if ($products.eq(firstItemIndex).length) {
                    // Fazer o scroll suave até o primeiro item da página atual
                    $('html, body').animate({
                        scrollTop: $products.eq(firstItemIndex).offset().top
                    }, 800);  // 800ms é a duração da animação, ajuste conforme necessário
                }
            }
        }
        }( jQuery ) );
    }
}

export default CategoryScripts